import { AffiliateWithdrawalTypesEnum } from 'modules/profile/affiliate-settings/enums/affiliate-withdrawal-enum'
import { TLocoType } from 'shared/hooks/use-loco-translation'

export const AffiliateWithdrawalCaptions = {
  [AffiliateWithdrawalTypesEnum.paypal]:
    'dashboard.user_settings.affiliate_commissions.payment_method.paypal',
  [AffiliateWithdrawalTypesEnum.bank_transfer]:
    'dashboard.user_settings.affiliate_commissions.payment_method.wire_transfer',
}

export function getAffiliateWithdrawalDataOptions(t: TLocoType) {
  return Object.entries(AffiliateWithdrawalCaptions).map(([type, caption]) => {
    return {
      id: type as AffiliateWithdrawalTypesEnum,
      caption: t(caption),
    }
  })
}
